import { useEffect, useState } from "react";
import { resetAllSelectedData } from "../redux/slices/allSelectedDataSlice";
import { resetAllStandardTenantData } from "../redux/slices/allStandardTenantSlice";
import { resetInvData } from "../redux/slices/investmentSlice";
import { resetPropertyData } from "../redux/slices/propertyslice";
import { resetPropertyManagerData } from "../redux/slices/propertyManagerSlice";
import { useDispatch } from "react-redux";
import { resetAmendmentTenatByPropertyData } from "../redux/slices/AmendmentTenatByPropertyDataSlice";



export const useResetReduxState = () => {
  const dispatch = useDispatch();

  const resetReduxState = () => {
    dispatch(resetAllSelectedData());
    dispatch(resetAllStandardTenantData());
    dispatch(resetAmendmentTenatByPropertyData());
    dispatch(resetInvData());
    dispatch(resetPropertyData());
    dispatch(resetPropertyManagerData());
  };

  return resetReduxState;
};

const useConfig = () => {
  const [config, setConfig] = useState<any>();

  useEffect(() => {

    const loadAsync = async () => {
      const sessionConfig = localStorage.getItem("config");
      if (sessionConfig) {
        setConfig(JSON.parse(sessionConfig));
        return;
      }

      const response = await fetch('appsettings.json');
      const json = await response.json();
      setConfig(json);
      localStorage.setItem("config", JSON.stringify(json));
    };
    loadAsync();
  }, []);

  return [config];
};

export default useConfig;

